import React, { useEffect, useState, useContext } from "react";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useLocation, useHistory } from "react-router";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { fetchCreateCommonCost } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { fetchOneProperty } from "../../helpers/api/condominium";
import { CurrencyContext } from "../../context/Context";
import CreateIndividualCostsForm from "../finance/CreateIndividualCostsForm";

const CreatePropertyIndividualCost = ({ setRedirectUrl, setRedirect }) => {
    const { property: propertyId } = useParams();
    const { currency: curr } = useContext(CurrencyContext);
    const activeExchangeRate = Number(curr?.value ?? 0);
    const { selectedCondominium } = useSelector((state) => state.condominium);
    const { state } = useLocation();
    const history = useHistory();
    const [propertyData, setPropertyData] = useState(null);
    const [isLoadingProperty, setIsLoadingProperty] = useState(true);

    useEffect(() => {
        let isMounted = true;
        if (propertyId) {
            (async () => {
                fetchOneProperty({ propertyId })
                    .then((val) => {
                        if (isMounted) setPropertyData(val.data);
                    })
                    .catch((error) => {
                        handleErrorMessage(error);
                    })
                    .finally(() => {
                        if (isMounted) setIsLoadingProperty(false);
                    });
            })();
        }
        return () => {
            isMounted = false;
        };
    }, [propertyId]);

    const create = async (values) => {
        try {
            const { code } = await fetchCreateCommonCost(
                selectedCondominium,
                {
                    ...values,
                    ...(activeExchangeRate ? { rate: activeExchangeRate } : {}),
                    type_id: 5,
                    property_id: propertyId,
                }
            );
            if (code === SUCCESS_RESPONSE.OK) {
                history.push({
                    pathname: `/dashboard/properties/advance/${propertyId}`,
                });

                Toast.fire({
                    type: "success",
                    title: `Cuenta por pagar registrada exitosamente.`,
                });
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    };

    return (
        <>
            <PageHeader
                title={state?.type_name || "Registrar cuenta por cobrar"}
                titleTag="h2"
                description={`Asigna un gasto a ${propertyData?.user?.data?.firstname || ""} ${propertyData?.user?.data?.lastname || ""}`}
                className="mb-3"
                col={{ lg: 9 }}
            >
                <SupportLink />
            </PageHeader>
            <PreloadState loading={isLoadingProperty}>
                {propertyData && (
                    <CreateIndividualCostsForm
                        handleSubmitData={create}
                        fixedProperty={propertyData}
                        // Pass empty handlers/data as we are in fixed property mode
                        handler={{}}
                        handlerM={{}}
                        metaa={{}}
                        properties={[]}
                    />
                )}
            </PreloadState>
        </>
    );
};

export default withRedirect(CreatePropertyIndividualCost);
